import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { WEB_ROUTES } from 'src/consts/routes';
import { AuthenticationService } from 'src/app/authentication/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class LoggedInAuthGuard  {
  constructor (private authService: AuthenticationService, private router: Router) { }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.currentUserValue) {
      return true;
    } else {
      this.router.navigate([WEB_ROUTES.DASHBOARD]);
      return false;
    }
  }
}
